export const FEEDBACK_REQUEST = "FEEDBACK_REQUEST";
export const FEEDBACK_SUCCESS = "FEEDBACK_SUCCESS";
export const FEEDBACK_FAILURE = "FEEDBACK_FAILURE";
export const FEEDBACKID_REQUEST = "FEEDBACKID_REQUEST";
export const FEEDBACKID_SUCCESS = "FEEDBACKID_SUCCESS";
export const FEEDBACKID_FAILURE = "FEEDBACKID_FAILURE";